import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styles from '../shared/styles';
import Smartuploader from '../../../../components/Smartuploader';
import { DivisionLabel, UploaderActionButtons } from '../shared/styled-components';

class Notes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: '',
    };

    this.resetImageUri = this.resetImageUri.bind(this);
    this.removeImageUri = this.removeImageUri.bind(this);
  }

  componentDidMount() {
    const { value } = this.props;
    this.setState({
      url: value,
    });
  }

  resetImageUri() {
    this.setState({
      url: ''
    });
  }

  removeImageUri() {
    this.resetImageUri();
    this.props.onFileRemove();
  }

  renderContent() {
    const { url } = this.state;
    const {
      episodeId,
      onUploadComplete,
      onUploadRemove,
      onUploadError,
      onImportComplete,
      onImportRemove,
      onImportError,
      persistUploaderOnSuccess,
    } = this.props;

    if (!isEmpty(url) && !persistUploaderOnSuccess) {
      return (
        <div style={styles.coverArtUploader}>
          <div style={styles.coverArt}>
            <img src={require('../../../../images/document-512x512.png')} alt="Documents"/>
            <UploaderActionButtons>
              <div className="action-buttons">
                <div className="icon-button">
                  <span className="material-icons" onClick={this.resetImageUri} title="Edit">edit</span>
                </div>
                <div className="icon-button">
                  <span className="material-icons" onClick={this.removeImageUri} title="Delete">delete</span>
                </div>
              </div>
            </UploaderActionButtons>
          </div>
        </div>
      );
    }

    return (
      <Smartuploader
        header={
          <React.Fragment>
            <span style={styles.miniSubheaderText}>(pdf, jpeg or png files accepted)</span>
          </React.Fragment>
        }
        fileuploader={{
          server: '/api/uploadv2',
          onprocessfile: onUploadComplete,
          onremovefile: onUploadRemove,
          onerror: onUploadError,
          acceptedFileTypes: [
            'image/png',
            'image/jpg',
            'image/jpeg',
            'application/pdf'
          ],
          fileValidateTypeLabelExpectedTypesMap: {
            'image/png': '.png',
            'image/jpg': '.jpg',
            'image/jpeg': '.jpeg',
            'application/pdf': '.pdf',
          },
          fileRenameFunction: file => {
            return `${episodeId}-notes${file.extension}`;
          },
          fileMetadataObject: { episodeId },
        }}
        linkuploader={{
          server: '/api/uploadv2',
          onimportcomplete: onImportComplete,
          onimportremove: onImportRemove,
          onimporterror: onImportError,
          metadataObject: {
            filerename: `${episodeId}-notes`,
            episodePropKey: 'notes',
            episodeId,
          },
        }}
      />
    );
  }

  render() {
    return (
      <div className="row" style={styles.rowDivision}>
        <div id="notes" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>
            Notes
          </DivisionLabel>
          {this.renderContent()}
        </div>
      </div>
    );
  }
}

Notes.propTypes = {
  episodeId: PropTypes.string,
  onUploadComplete: PropTypes.func,
  onUploadRemove: PropTypes.func,
  onUploadError: PropTypes.func,
  onFileRemove: PropTypes.func,
  onImportComplete: PropTypes.func,
  onImportRemove: PropTypes.func,
  onImportError: PropTypes.func,
  persistUploaderOnSuccess: PropTypes.bool,
};

Notes.defaultProps = {
  episodeId: '',
  onUploadComplete: () => {},
  onUploadRemove: () => {},
  onUploadError: () => {},
  onFileRemove: () => {},
  onImportComplete: () => {},
  onImportRemove: () => {},
  onImportError: () => {},
  persistUploaderOnSuccess: false,
};

export default Notes;